export enum ToastMessagesCodes {
    NewPassword = 'newPassword',
    EmailConfirmed = 'emailConfirmed',
    EmailConfirmFailed = 'emailConfirmFailed'
}
